import React from "react";

function SpeechButton({ text, lang, label }) {
  const speak = () => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = 0.8; // slow for clarity
    window.speechSynthesis.speak(utterance);
  };

  return <button onClick={speak}>🔊 {label}</button>;
}

export default SpeechButton;
